// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CycleTimeAnalyticsSection } from '@/report/components/cycle-time-analytics-section';
import { OUTBOUND_SHIPMENT_CYCLE_TIME_SEGMENTS } from '@/shipment/components/shipment-cycle-time-segments';
import { useOutboundShipmentCycleTimeReport } from '@/shipment/hooks/use-outbound-shipment-cycle-time-report';
import type { DateRange } from '@mui/x-date-pickers-pro';
import type { DateTime, IANAZone, Interval } from 'luxon';

const OUTBOUND_SHIPMENT_CYCLE_TIME_ACCORDION_EXPANDED_STORAGE_KEY =
  'outbound-shipment-cycle-time-accordion-expanded';

interface OutboundShipmentAnalyticsSectionProps {
  interval: Interval;
  timezone: IANAZone;
  isDateRangeInvalid: boolean;
  onDateRangeChange: (dateRange: DateRange<DateTime>) => void;
}

function useOutboundShipmentCycleTimeReportQuery(filter: {
  interval: Interval;
}) {
  return useOutboundShipmentCycleTimeReport({ filter });
}

export function OutboundShipmentAnalyticsSection(
  props: OutboundShipmentAnalyticsSectionProps
) {
  return (
    <CycleTimeAnalyticsSection
      interval={props.interval}
      timezone={props.timezone}
      isDateRangeInvalid={props.isDateRangeInvalid}
      onDateRangeChange={props.onDateRangeChange}
      segments={OUTBOUND_SHIPMENT_CYCLE_TIME_SEGMENTS}
      singularNoun="shipment"
      domIdPrefix="outbound-shipment-cycle-time"
      expandedStorageKey={
        OUTBOUND_SHIPMENT_CYCLE_TIME_ACCORDION_EXPANDED_STORAGE_KEY
      }
      errorBoundaryMessage="Failed to load outbound shipment cycle time report"
      summarySkeletonWidthPx={220}
      useReportQuery={useOutboundShipmentCycleTimeReportQuery}
      getTotalCount={(report) => report.totalShipments}
    />
  );
}
